/* V2-PAGES 04/11 chantier B : sommaire ancré des politiques (/policies/*), construit depuis les titres déjà servis.
   N'ajoute que des ancres (id) et une liste de liens ; aucun texte de la politique n'est modifié.
   Les politiques sans titres (expédition : paragraphes « 1. … » en gras) utilisent ces paragraphes comme repères. */
(function () {
  'use strict';
  var LBL = { fr: 'Sommaire', en: 'Contents', de: 'Inhalt', es: 'Índice', it: 'Indice', pt: 'Índice', nl: 'Inhoud', pl: 'Spis treści' };
  function run() {
    var c = document.querySelector('.shopify-policy__container');
    if (!c || c.querySelector('.r36pb-toc')) return;
    var body = c.querySelector('.shopify-policy__body');
    if (!body) return;
    var marks = [].slice.call(body.querySelectorAll('h2, h3'));
    if (marks.length < 3) {
      marks = [].slice.call(body.querySelectorAll('p > strong:first-child')).filter(function (s) {
        return /^\s*\d+\s*[.)]/.test(s.textContent || '');
      });
    }
    if (marks.length < 3) return;
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var nav = document.createElement('details');
    nav.className = 'r36pb-toc';
    var sum = document.createElement('summary');
    sum.textContent = (LBL[lang] || LBL.en) + ' · ' + marks.length;
    nav.appendChild(sum);
    var ol = document.createElement('ol');
    marks.forEach(function (m, i) {
      var target = m.tagName === 'STRONG' ? m.parentNode : m;
      if (!target.id) target.id = 'r36pb-s' + (i + 1);
      target.classList.add('r36pb-anchor');
      if (m.tagName === 'STRONG') target.classList.add('r36pb-anchor--p');
      var li = document.createElement('li');
      if (m.tagName === 'H3' && marks.some(function (x) { return x.tagName === 'H2'; })) li.className = 'is-sub';
      var a = document.createElement('a');
      a.href = '#' + target.id;
      a.textContent = (m.textContent || '').replace(/\s+/g, ' ').trim();
      li.appendChild(a);
      ol.appendChild(li);
    });
    nav.appendChild(ol);
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) nav.open = true;
    c.classList.add('has-toc');
    body.parentNode.insertBefore(nav, body);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
